import axios from 'axios';
import qs from 'qs';
import Api from '../config';
import store from '../store';
import router from '../router';
import {
  getItem,
  spliceToken
} from '../common/js/util'
const instance = axios.create({
  baseURL: Api.baseUrl,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
});

// 错误信息处理函数
const handleErrorMsg = function(res) {
  if (res.Success !== true) {
    store.commit('setErrorMsg', res.ErrorMsg)
    store.commit('setRequestErr', true)
  }

  return res
}

instance.interceptors.request.use(config => {
  if (config.method === 'post') {

    return config;
  }
  return config;
}, err => {
  return Promise.reject(err);
});

instance.interceptors.response.use(res => {

  if (res.status != 200) {
    return Promise.reject(res);
  }
  return res;
}, err => {
  console.warn(err);
  return Promise.reject(err);
});

const postWrap = (url, params) => {
  return new Promise((resolve, reject) => {
    instance.post(url, params).then(({
      data
    }) => resolve(data)).catch(err => reject(err));
  })
}

const getWrap = (url, params) => {
  return new Promise((resolve, reject) => {
   
    instance.get(url, {params}).then(({
      data
    }) => resolve(data)).catch(err => reject(err));
  })
}
/**
 * JSON 转字符串
 * @Author   lyj
 * @DateTime 2018-08-02T11:11:34+0800
 * @param    {{JSON 转字符串}}
 * @param    {[json & json字符串]}                 param [description]
 * @return   {[string]}                       [description]
 */
const toParams = (param) => {
    var result = ""
    for (let name in param) {
        if (typeof param[name] != 'function') {
            result += "&" + name + "=" + encodeURI(param[name]);
        }
    }
    return result.substring(1)
}
const configParams = (param) => {
    var result = ""
    for (let name in param) {
        if (typeof param[name] != 'function') {
          console.log(name)
          if ( name == 'data') {
            result += "&" + name + "=" + param[name];
          }else{
            result += "&" + name + "=" + encodeURI(param[name]);
          }
        }
    }
    return result.substring(1)
}
/**
 * 获取验证码
 * @Author   lyj
 * @DateTime 2018-08-02T11:34:09+0800
 * @param    {{loginTd 手机号码}}
 * @param    {[string]}                 params [description]
 * @return   {[type]}                        [description]
 */
export const validCode = params => {
  const url = '/rest/api/wechat/auth/validcode';

  const Defaults = {
    mobile:'',
    orgid:Api.orgid
  }
  params = Object.assign({}, Defaults, params);
  params = toParams(params);

  return postWrap(url, params)
}
/**
 * 注册 POST
 * 参数：
 * loginId：登陆会员手机号
 * validcode：验证码
 * orgid：租户ID
 * passWord：密码
 * srcType：登陆来源 （手机端：mobile网页端：web POS：pos :小程序：miniApp）
 * domain：登陆方合法域名
 * storeId：店铺ID，分配的店铺ID，不传可能导致报错
 * sex：性别(男/女)，默认 男
 */
export const Regist = params => {
  const url = '/rest/api/crm/login/auth/regist';

  const Defaults = {
    loginId:'',
    validcode:'',
    orgid:Api.orgid,
    passWord:'',
    srcType:'web',
    passWord:'',
    storeId:'',
    sex:''
  }
  params = Object.assign({}, Defaults, params);
  params = toParams(params);

  return postWrap(url, params)
}
/**
 * 修改密码 POST
 * 参数：
 * loginId：登陆会员手机号
 * validcode：验证码
 * orgid：租户ID
 * passWord：密码
 * srcType：登陆来源 （手机端：mobile网页端：web POS：pos :小程序：miniApp）
 * domain：登陆方合法域名
 * storeId：店铺ID，分配的店铺ID，不传可能导致报错
 * sex：性别(男/女)，默认 男
 */
export const EditPwd = params => {
  const url = '/rest/api/crm/login/auth/modifypwd';

  const Defaults = {
    loginId:'',
    validcode:'',
    orgid:Api.orgid,
    oldPwd:'',
    passWord1:'',
    passWord2:'',
    srcType:'web',
    passWord:'',
    storeId:'',
    sex:''
  }
  params = Object.assign({}, Defaults, params);
  params = toParams(params);

  return postWrap(url, params)
}

/**
 * Login
 * 登录 post
 * loginId, validcode
 */
export const Login = params => {
  const url = '/rest/api/wechat/auth/login';

  const Defaults = {
    loginId:'',
    validcode:'',
    orgid:Api.orgid,
    srcType:'web',
    passWord:'',
    openid:getItem('openid')
  }
  params = Object.assign({}, Defaults, params);
  params = toParams(params);

  return postWrap(url, params)
}
/**
 * 判断是不能是会员
 * @Author   lyj
 * @DateTime 2019-02-27T15:09:57+0800
 * @param    {{描述}}
 * @param    {[type]}                 params [description]
 * @return   {[type]}                        [description]
 */
export const IsVip = params => {
  const url = '/rest/api/pos/cash/fetch_member';

  const Defaults = {
    code:'',
    access_token:''
  }
  params = Object.assign({}, Defaults, params);
  // params = toParams(params);

  return getWrap(url, params)
}
/**
 * 获取地区信息
 * @Author   lyj
 * @DateTime 2019-02-28T09:35:48+0800
 * @param    {{描述}}
 * @param    {[type]}                 params [description]
 * @return   {[type]}                        [description]
 */
export const GetArea = params => {
  const url = '/rest/api/crm/login/getorgstores';

  const Defaults = {
    access_token:'',
    orgid:Api.orgid
  }
  params = Object.assign({}, Defaults, params);
  params = toParams(params);

  return postWrap(url, params)
}
/**
 * 获取门店信息
 * @Author   lyj
 * @DateTime 2019-02-28T09:36:10+0800
 * @param    {{描述}}
 * @param    {[type]}                 params [description]
 * @return   {[type]}                        [description]
 */
export const GetStoreList = params => {
  const url = '/rest/api/crm/login/getregioncompany';

  const Defaults = {
    access_token:'',
    region_id:'',
    orgid:Api.orgid
  }
  params = Object.assign({}, Defaults, params);
  params = toParams(params);

  return postWrap(url, params)
}
/**
 * [获取用户信息]
 * @Author   lyj
 * @DateTime 2018-08-07T15:48:38+0800
 * @param    {{token}}
 * @param    {[string]}                 params [description]
 * @return   {[obj]}                        [description]
 */
export const getUser = params => {
  const url = '/rest/api/wechat/my/fetch_member';

  const Defaults = {
    access_token:'',
    orgid:Api.orgid
  }
  params = Object.assign({}, Defaults, params);
  return getWrap(url, params)
}
/**
 * [获取会员卡信息]
 * @Author   lyj
 * @DateTime 2018-08-08T11:44:10+0800
 * @param    {{code 会员号}}
 * @param    {[string]}                 params [description]
 * @return   {[obj]}                        [description]
 */
export const getCardList = params => {
  const url = '/rest/api/wechat/my/fetch_card_list';

  const Defaults = {
    code:'',
    access_token:'',
    orgid:Api.orgid
  }
  params = Object.assign({}, Defaults, params);
  return getWrap(url, params)
}
/**
 * [会员卡详情]
 * @Author   lyj
 * @DateTime 2018-11-30T11:49:49+0800
 * @param    {{描述}}
 * @param    {[type]}                 params [description]
 * @return   {[type]}                        [description]
 */
export const getCardDetail = params => {
  const url = '/rest/api/wechat/my/fetch_card_detail';

  const Defaults = {
    card_code:'',
    access_token:'',
    orgid:Api.orgid
  }
  params = Object.assign({}, Defaults, params);
  return getWrap(url, params)
}
/**
 * [会员权益]
 * @Author   lyj
 * @DateTime 2018-11-30T11:50:05+0800
 * @param    {{描述}}
 * @param    {[type]}                 params [description]
 * @return   {[type]}                        [description]
 */
export const getMemberDetail = params => {
  const url = '/rest/api/crm/login/get/mempowerinfo';

  const Defaults = {
    access_token:'',
    orgId:Api.orgid,
    appid:Api.appid
  }
  params = Object.assign({}, Defaults, params);
  params = toParams(params);
  return postWrap(url, params)
}
/**
 * [获取订单列表]
 * @Author   lyj
 * @DateTime 2018-08-08T16:27:15+0800
 * @param    {{描述}}
 * @param    {[pstring]}                 params [status，page，rows]
 * @return   {[type]}                        [description]
 */
// export const getOrderList = params => {
//   const url = '/rest/api/wechat/order/fetch_order_list';

//   const Defaults = {
//     status:'',
//     access_token:'',
//     order_src:'',
//     orgid:Api.orgid,
//     page:'',
//     row:''
//   }
//   params = Object.assign({}, Defaults, params);
//   // params = toParams(params);
//   return getWrap(url, params)
// }
export const getOrderList = params => {
  const url = '/rest/api/wechat/order/fetch_memorder_list';

  const Defaults = {
    status:'',
    access_token:'',
    order_src:'',
    orgid:Api.orgid,
    page:'',
    row:''
  }
  params = Object.assign({}, Defaults, params);
  params = toParams(params);
  return postWrap(url, params)
}
/**
 * [积分兑换列表]
 * @Author   lyj
 * @DateTime 2018-08-10T15:32:43+0800
 * @param    {{token，memberId，type}}
 * @param    {[string]}                 params [description]
 * @return   {[type]}                        [description]
 */
export const getIntegral = params => {
  const url = '/rest/api/crm/integral/getcanusecoupons';

  const Defaults = {
    type:'',
    access_token:'',
    memberId:'',
    orgid:Api.orgid,
  }
  params = Object.assign({}, Defaults, params);
  params = toParams(params);
  return postWrap(url, params)
}
/**
 * [我的优惠券]
 * @Author   lyj
 * @DateTime 2018-08-14T11:16:08+0800
 * @param    {{type，token，memberId，orgId}}
 * @param    {[type]}                 params [description]
 * @return   {[type]}                        [description]
 */
export const getMyIntegral = params => {
  const url = '/rest/api/crm/integral/getmemcoupons';

  const Defaults = {
    type:'',
    access_token:'',
    memberId:'',
    orgid:Api.orgid,
  }
  params = Object.assign({}, Defaults, params);
  params = toParams(params);
  return postWrap(url, params)
}
/**
 * [优惠券详情]
 * @Author   lyj
 * @DateTime 2018-08-14T18:53:17+0800
 * @param    {{描述}}
 * @param    {[type]}                 params [description]
 * @return   {[type]}                        [description]
 */
export const CouponsDetail = params => {
  const url = '/rest/api/crm/integral/getcouponsdetail';

  const Defaults = {
    couponId:'',
    access_token:'',
    orgid:Api.orgid,
  }
  params = Object.assign({}, Defaults, params);
  params = toParams(params);
  return postWrap(url, params)
}
/**
 * [积分流水]
 * @Author   lyj
 * @DateTime 2018-08-14T18:53:17+0800
 * @param    {{描述}}
 * @param    {[type]}                 params [description]
 * @return   {[type]}                        [description]
 */
export const getIntegraldetail = params => {
  const url = '/rest/api/crm/integral/getintegralflow';

  const Defaults = {
    type:'',
    access_token:'',
    memberId:'',
    rows:'',
    pages:'',
    orgid:Api.orgid,
  }
  params = Object.assign({}, Defaults, params);
  params = toParams(params);
  return postWrap(url, params)
}
/**
 * [兑换详情]
 * @Author   lyj
 * @DateTime 2018-08-14T18:53:17+0800
 * @param    {{描述}}
 * @param    {[type]}                 params [description]
 * @return   {[type]}                        [description]
 */
export const getFlowdetail = params => {
  const url = '/rest/api/crm/integral/getflowdetail';

  const Defaults = {
    uuid:'',
    access_token:'',
    orgid:Api.orgid,
  }
  params = Object.assign({}, Defaults, params);
  // params = toParams(params);
  return getWrap(url, params)
}

/**
 * 获取首页轮播图
 * @Author   lyj
 * @DateTime 2018-08-20T09:34:12+0800
 * @param    {{描述}}
 * @param    {[type]}                 params [description]
 * @return   {[type]}                        [description]
 */
export const getAdvList = params => {
  const url = '/rest/api/wechat/index/banner_list';

  const Defaults = {
    orgid:Api.orgid,
  }
  params = Object.assign({}, Defaults, params);
  // params = toParams(params);
  return getWrap(url, params)
}
/**
 * 上传头像
 * @Author   lyj
 * @DateTime 2018-08-16T15:17:15+0800
 * @param    {{描述}}
 * @param    {[type]}                 params [description]
 * @return   {[type]}                        [description]
 */
export const UploadImg = params => {
  const url = '/rest/api/wechat/my/modifyMemImg';

  const Defaults = {
    orgid:Api.orgid,
  }
  params = Object.assign({}, Defaults, params);
  params = toParams(params);
  return postWrap(url, params)
}
/**/


/**
 * [积分兑换详情]
 * @Author   lyj
 * @DateTime 2018-08-14T18:53:17+0800
 * @param    {{描述}}
 * @param    {[type]}                 params [description]
 * @return   {[type]}                        [description]
 */
export const getCouponsDetail = params => {
  const url = '/rest/api/crm/integral/getcouponsdetail';

  const Defaults = {
    access_token:'',
    couponId:'',
    orgid:Api.orgid,
  }
  params = Object.assign({}, Defaults, params);
  params = toParams(params);
  return postWrap(url, params)
}

export const getScan = params => {
  const url = '/rest/api/crm/integral/auto_add_mem_package';

  const Defaults = {
    access_token:'',
    member_id:'',
		code:'',
    orgid:Api.orgid,
  }
  params = Object.assign({}, Defaults, params);
  params = toParams(params);
  return postWrap(url, params)
}
/**
 * 积分兑换
 * @Author   lyj
 * @DateTime 2018-08-20T11:28:13+0800
 * @param    {{描述}}
 * @param    {[type]}                 params [description]
 * @return   {[type]}                        [description]
 */
export const IntegralExchange = params => {
  const url = '/rest/api/crm/integral/confirmgetcoupons';

  const Defaults = {
    access_token:'',
    uuid:'',
    memberId:'',
    orgid:Api.orgid,
  }
  params = Object.assign({}, Defaults, params);
  params = toParams(params);
  return postWrap(url, params)
}
/**
 * 修改会员信息
 * @Author   lyj
 * @DateTime 2018-08-20T15:52:14+0800
 * @param    {{描述}}
 * @param    {[type]}                 params [description]
 * @return   {[type]}                        [description]
 */
export const EditInfo = params => {
  const url = '/rest/api/wechat/my/modifyMemInfo';

  const Defaults = {
    access_token:'',
    uuid:'',
    memberId:'',
    orgid:Api.orgid,
  }
  params = Object.assign({}, Defaults, params);
  params = toParams(params);
  return postWrap(url, params)
}
/**
 * 会员卡绑定
 * @Author   lyj
 * @DateTime 2018-08-27T14:25:45+0800
 * @param    {{描述}}
 * @param    {[token,code]}                 params [description]
 * @return   {[type]}                        [description]
 */
export const BindCard = params => {
  const url = '/rest/api/wechat/my/bind_card';

  const Defaults = {
    access_token:'',
    card_code:'',
    orgid:Api.orgid,
  }
  params = Object.assign({}, Defaults, params);
  params = toParams(params);
  return postWrap(url, params)
}
/**
 * 获取微信配置信息
 * @Author   lyj
 * @DateTime 2018-10-15T11:03:04+0800
 * @param    {{描述}}
 * @param    {[type]}                 params [description]
 * @return   {[type]}                        [description]
 */
export const getWxConfig = params =>{
  const url = '/rest/api/wechat/my/getjsapisign';
  const Defaults = {
    access_token:'',
    orgid:Api.orgid,
    data:''
  }
  params = Object.assign({}, Defaults, params);
  params = toParams(params);
  return postWrap(url, params)
}
/**
 * 获取微信会员卡
 * @Author   lyj
 * @DateTime 2018-10-12T14:16:58+0800
 * @param    {{描述}}
 * @param    {[type]}                 params [description]
 * @return   {[type]}                        [description]
 */
export const getWxCard = params =>{
  const url = '/rest/api/wechat/my/getacccardinfo';

  const Defaults = {
    access_token:'',
    orgid:Api.orgid,
    memberId:''
  }
  params = Object.assign({}, Defaults, params);
  params = toParams(params);
  return postWrap(url, params)
}
/**
 * 获取微信卡券
 * @Author   lyj
 * @DateTime 2018-10-12T14:16:58+0800
 * @param    {{描述}}
 * @param    {[type]}                 params [description]
 * @return   {[type]}                        [description]
 */

export const getAddCouponCardInfo = params =>{
  const url = '/rest/api/wechat/my/getaddcouponcardinfo';

  const Defaults = {
    access_token:'',
    orgid:Api.orgid
  }
  params = Object.assign({}, Defaults, params);
  params = toParams(params);
  return postWrap(url, params)
}
/**
 * 获取openid
 * @Author   lyj
 * @DateTime 2018-10-12T14:16:58+0800
 * @param    {{描述}}
 * @param    {[code]}                 params [description]
 * @return   {[openid]}                        [description]
 */

export const getOpenId = params =>{
  const url = '/rest/api/crm/login/get/openid';

  const Defaults = {
    code:'',
    orgid:Api.orgid
  }
  params = Object.assign({}, Defaults, params);
  params = toParams(params);
  return postWrap(url, params)
}
/**
 * 判断是否登录
 * @Author   lyj
 * @DateTime 2018-10-12T14:16:58+0800
 * @param    {{描述}}
 * @param    {[code]}                 params [description]
 * @return   {[openid]}                        [description]
 */

export const IsFocus = params =>{
  const url = '/rest/api/crm/login/testmemfocusegzh';

  const Defaults = {
    openid:'',
    orgid:Api.orgid
  }
  params = Object.assign({}, Defaults, params);
  params = toParams(params);
  return postWrap(url, params)
}
/**
 * 获取店铺getStore
 * @Author   lyj
 * @DateTime 2018-10-12T14:16:58+0800
 * @param    {{描述}}
 * @param    {[经纬度]}                 params [description]
 * @return   {[openid]}                        [description]
 */

export const getStore = params =>{
  const url = '/rest/api/wechat/buy/store_list';

  const Defaults = {
    orgid:Api.orgid
  }
  params = Object.assign({}, Defaults, params);
  return getWrap(url, params)
}
/**
 * 获取验证token
 * @Author   lyj
 * @DateTime 2018-10-12T14:16:58+0800
 * @param    {{描述}}
 * @param    {[code]}                 params [description]
 * @return   {[openid]}                        [description]
 */

export const getVaildToken = params =>{
  const url = '/rest/api/auth/fetch_token';

  const Defaults = {
    orgid:Api.orgid,
    // 陕西西店
    // userId:'admin_sx',
    // passwd:'sxxd123'
    // 河北正式
    // userId:'crmhb',
    // passwd:'123456'
    // 测试环境
    userId:Api.userId,
    passwd:Api.passwd
  }
  params = Object.assign({}, Defaults, params);
  params = toParams(params);
  return postWrap(url, params)
}



// WEBPACK FOOTER //
// ./src/api/index.js